import { Controller } from "@hotwired/stimulus"

// A custom-field row: the options input only makes sense for a list.
export default class extends Controller {
  static targets = ["type", "options"]

  connect() { this.refresh() }

  refresh() {
    this.optionsTarget.classList.toggle("hidden", this.typeTarget.value !== "select_list")
  }
}
